import {
  ContadoresRVPersonInput,
  ContadoresRVBillAutoInput,
  ContadoresRVBillInput,
  ContadoresRVPayBillInput,
} from "../../interface/client";

export class SearchClients {
  static readonly type = "[Client] Query SearchClients";
  constructor(public readonly criteria: string, public readonly Category: string) {}
}

export class CreateClient {
  static readonly type = "[Client] Mutation CreateClient";
  constructor(public readonly data: ContadoresRVPersonInput) {}
}

export class UpdateClient {
  static readonly type = "[Client] Mutation UpdateClient";
  constructor(public readonly data: ContadoresRVPersonInput) {}
}

export class ClearBillAutos {
  static readonly type = "[Client] Action ClearBillAutos";
  constructor() {}
}

export class ClearBills {
  static readonly type = "[Client] Action ClearBills";
  constructor() {}
}

/** Clears `clientProfile` + `registryDraft` (active lookup / perfil). */
export class ClearClientLookup {
  static readonly type = "[Client] ClearClientLookup";
  constructor() {}
}

export class CreateBillAuto {
  static readonly type = "[Client] Mutation CreateBillAuto";
  constructor(public readonly data: ContadoresRVBillAutoInput) {}
}

export class UpdateBillAuto {
  static readonly type = "[Client] Mutation UpdateBillAuto";
  constructor(public readonly data: ContadoresRVBillAutoInput) {}
}

export class CreateBill {
  static readonly type = "[Client] Mutation CreateBill";
  constructor(public readonly data: ContadoresRVBillInput) {}
}

export class UpdateBillNotes {
  static readonly type = "[Client] Mutation UpdateBillNotes";
  constructor(public readonly data: ContadoresRVBillInput) {}
}

export class CreatePayment {
  static readonly type = "[Client] Mutation CreatePayment";
  constructor(public readonly data: ContadoresRVPayBillInput) {}
}

export class LoadBillAutosByClient {
  static readonly type = "[Client] Query LoadBillAutosByClient";
  constructor(public readonly personId: string) {}
}

export class LoadClientBalanceByState {
  static readonly type = "[Client] Query LoadClientBalanceByState";
  constructor(
    public readonly personId: string,
    public readonly state: number
  ) {}
}

export class LoadBillsBalanceByCriteria {
  static readonly type = "[Client] Query LoadBillsBalanceByCriteria";
  constructor(
    public readonly criteria: string,
    public readonly state: string,
    public readonly start: Date,
    public readonly end: Date,
    public readonly category: string,
  ) {}
}

export class PayAllBillsForClient {
  static readonly type = "[Client] Mutation PayAllBillsForClient";
  constructor(public readonly data: ContadoresRVPayBillInput) {}
}

export class LoadBillsByClientAndState {
  static readonly type = "[Client] Query LoadBillsByClientAndState";
  constructor(
    public readonly personId: string,
    public readonly state: number,
    public readonly isNew: boolean
  ) {}
}

export class LoadBillsByClient {
  static readonly type = "[Client] Query LoadBillsByClient";
  constructor(
    public readonly personId: string,
    public readonly state: string,
    public readonly start: Date,
    public readonly end: Date,
    public readonly isNew: boolean
  ) {}
}

export class LoadBillsByCriteria {
  static readonly type = "[Client] Query LoadBillsByCriteria";
  constructor(
    public readonly criteria: string,
    public readonly state: string,
    public readonly start: Date,
    public readonly end: Date,
    public readonly category: string,
    public readonly isNew: boolean
  ) {}
}

export class LoadPaymentsByBill {
  static readonly type = "[Client] Query LoadPaymentsByBill";
  constructor(public readonly billId: string) {}
}

export class LoadClientByDocumentId {
  static readonly type = "[Client] Query LoadClientByDocumentId";
  constructor(public readonly DocumentId: string) {}
}

export class SetViewMode {
  static readonly type = "[Client] SetViewMode";
  constructor(public readonly ViewMode: string) {}
}

export class AnnulBill {
  static readonly type = "[Client] Mutation AnnulBill";
  constructor(public readonly id: string) {}
}
